import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';

const rootEl = document.getElementById('root')!;
// Wipe the pre-React splash (see index.html) before React mounts so the
// static logo doesn't briefly overlap the mounted app.
rootEl.innerHTML = '';

ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
